import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./Footer";
import Hero from "./pages/Hero";
import Navbar from "./Navbar";
import Services from "./pages/Services"; 
import Safety from "./pages/Safety";
import ServiceArea from "./pages/ServiceArea";
import AboutUs from "./pages/AboutUs";
import RequestAppointment from "./pages/RequestAppointment";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/services" element={<Services />} />
        {/* Add routes for other pages */}
        <Route path="/service-area" element={<ServiceArea/>} />
        <Route path="/safety" element={<Safety/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="/request-appointment" element={<RequestAppointment/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms-of-service" element={<TermsOfService/>} />
        {/* Optional: Fallback for undefined routes */}
        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;